<!-- 底部 -->
<template>
  <div class="intro-bottom-copy" v-html="copyright"></div>
</template>

<script>
import { copyright } from '@/constant'
export default {
  name: '',
  components: {},
  data () {
    return {
      copyright
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
